
<ng-container *ngIf="!isMultiple">
    <mat-form-field
        *transloco="let translate"
        [appearance]="appearance"
        [class.noHints]="noHints"
        [class.noLabel]="noLabel"
        appRemoveAriaOwns
        [appTailwindMaterial]="tailwindClasses"
        [valueDependent]="model">
        <mat-label *ngIf="placeholder && !noLabel">{{ placeholder }}</mat-label>
        <mat-select
            [formControl]="control"
            [errorStateMatcher]="matcher"
            disableOptionCentering
            (selectionChange)="errors?.splice(0, 1)"
            [title]="getTooltipTitle()"
            [placeholder]="noLabel ? placeholder : ''"
            [panelClass]="panelClass">
            <mat-select-trigger>
                <span
                    [textContent]="
                        selectedOption?.translate
                            ? translate(getOptionDisplayText(selectedOption))
                            : getOptionDisplayText(selectedOption) || (noLabel ? placeholder : '')
                    "></span>
            </mat-select-trigger>
            <mat-option
                *ngIf="hideSelectIfValueExists !== undefined ? model !== undefined && !hideSelectIfValueExists : true"
                [title]="translate('Please select')">
                <div class="option-text-wrapper">
                    <em>
                        --
                        <span [textContent]="translate('Please select')"></span>
                        --
                    </em>
                </div>
                <div *ngIf="createOptionRequired" class="option-actions-wrapper">
                    <material-button
                        buttonType="icon"
                        size="small"
                        [titleText]="translate('Create New')"
                        prefixIconType="material"
                        prefixIcon="add_circle"
                        (buttonClicked)="$event.stopPropagation(); $event.preventDefault(); createOptionCallBack.emit()"></material-button>
                </div>
            </mat-option>
            <ng-container *ngIf="options && options.length > 0">
                <div class="selectSearchFilter addToIgnoreList" *ngIf="!isSearchNotRequired">
                    <mat-form-field>
                        <mat-label *transloco="let translate">{{ translate('Search') }}</mat-label>
                        <input
                            matInput
                            class="inputSearchField addToIgnoreList"
                            autocomplete="off"
                            [(ngModel)]="searchColumns"
                            (keydown)="$event.stopPropagation()" />
                        <material-button
                            matSuffix
                            buttonType="icon"
                            size="small"
                            [titleText]="'Clear'"
                            prefixIconType="material"
                            prefixIcon="close"
                            (buttonClicked)="$event.stopPropagation(); searchColumns = ''"></material-button>
                    </mat-form-field>
                </div>
                <mat-option
                    *ngFor="
                        let option of options
                            | FilterPipe
                                : optionValueProperty || 'value'
                                : searchColumns
                                : null
                                : optionDisplayNameProperty || 'displayName'
                    "
                    [value]="getOptionValue(option)"
                    (click)="sendOptionsData(option); selectedOption = option"
                    [title]="option.translate ? translate(getOptionDisplayText(option)) : getOptionDisplayText(option)">
                    <div class="option-text-wrapper">
                        <span
                            [textContent]="
                                option.translate ? translate(getOptionDisplayText(option)) : getOptionDisplayText(option)
                            "></span>
                    </div>
                    <div *ngIf="option.actionsRequired" class="option-actions-wrapper" (click)="$event.stopPropagation()">
                        <material-button
                            *ngFor="let action of option.actions"
                            buttonType="icon"
                            size="small"
                            [titleText]="action.name"
                            prefixIconType="material"
                            [prefixIcon]="action.icon"
                            (buttonClicked)="
                                $event.stopPropagation(); $event.preventDefault(); editOptionCallBack.emit(option)
                            "></material-button>
                    </div>
                </mat-option>
                <mat-option
                    *ngIf="
                        (
                            options
                            | FilterPipe
                                : optionValueProperty || 'value'
                                : searchColumns
                                : null
                                : optionDisplayNameProperty || 'displayName'
                        ).length === 0
                    "
                    [title]="translate('No results found')">
                    <span [textContent]="translate('No results found')"></span>
                </mat-option>
                <!-- <mat-option class="create-new" *ngIf="createOptionRequired" (click)="$event.stopPropagation(); $event.preventDefault(); createOptionCallBack.emit()">
                    <material-button class="flex justify-around" [text]="translate('Create New')">
                    </material-button>
                </mat-option> -->
            </ng-container>
        </mat-select>
        <material-button
            *ngIf="description && description.length > 0"
            matSuffix
            buttonType="icon"
            size="small"
            prefixIcon="info"
            prefixIconType="material"
            [titleText]="description"
            tabindex="-1"></material-button>
        <mat-hint align="start" *ngIf="required && !(errors && errors.length > 0) && !noHints">
            <strong>
                <span>*</span>
                <span [textContent]="translate('required')"></span>
            </strong>
        </mat-hint>
        <mat-error *ngIf="control.hasError('errors') && !noHints" [title]="errors">
            <span [textContent]="errors"></span>
        </mat-error>
    </mat-form-field>
</ng-container>

<ng-container *ngIf="isMultiple">
    <mat-form-field *transloco="let translate" appRemoveAriaOwns>
        <mat-label *ngIf="placeholder">{{ placeholder }}</mat-label>
        <mat-select
            multiple
            [formControl]="control"
            [errorStateMatcher]="matcher"
            disableOptionCentering
            (selectionChange)="errors?.splice(0, 1)"
            [title]="getTooltipTitle()"
            [panelClass]="panelClass">
            <ng-container *ngIf="options && options.length > 0">
                <div class="selectSearchFilter addToIgnoreList" *ngIf="!isSearchNotRequired">
                    <mat-form-field>
                        <mat-label *transloco="let translate">{{ translate('Search') }}</mat-label>
                        <input
                            matInput
                            class="inputSearchField addToIgnoreList"
                            autocomplete="off"
                            [(ngModel)]="searchColumns"
                            (keydown)="$event.stopPropagation()" />
                        <material-button
                            matSuffix
                            buttonType="icon"
                            size="small"
                            [titleText]="'Clear'"
                            prefixIconType="material"
                            prefixIcon="close"
                            (buttonClicked)="$event.stopPropagation(); searchColumns = ''"></material-button>
                    </mat-form-field>
                </div>
                <mat-option
                    *ngFor="
                        let option of options | FilterPipe : 'value' : searchColumns : null : optionDisplayNameProperty || 'displayName'
                    "
                    [value]="getOptionValue(option)"
                    (click)="sendOptionsData(option)"
                    [title]="option.translate ? translate(getOptionDisplayText(option)) : getOptionDisplayText(option)">
                    <span [textContent]="option.translate ? translate(getOptionDisplayText(option)) : getOptionDisplayText(option)"></span>
                </mat-option>
            </ng-container>
        </mat-select>
        <material-button
            *ngIf="description && description.length > 0"
            matSuffix
            buttonType="icon"
            size="small"
            prefixIcon="info"
            prefixIconType="material"
            [titleText]="description"
            tabindex="-1"></material-button>
        <mat-hint align="start" *ngIf="required && !(errors && errors.length > 0) && !noHints">
            <strong>
                <span>*</span>
                <span [textContent]="translate('required')"></span>
            </strong>
        </mat-hint>
        <mat-hint align="start" *ngIf="!required && !(errors && errors.length > 0) && hint && hint.length > 0 && !noHints">
            <span [textContent]="hint"></span>
        </mat-hint>
        <mat-error *ngIf="control.hasError('errors') && !noHints" [title]="errors">
            <span [textContent]="errors"></span>
        </mat-error>
    </mat-form-field>
</ng-container>
